import { Injectable } from '@angular/core';

import { Http } from '@angular/http';

import { UserData } from '../user-data';
import { CommonData } from '../../providers/common-data';
import { NativeScriptHttpModule } from "nativescript-angular/http";
import { OpenALPR, OpenALPROptions, OpenALPRResult } from '@ionic-native/openalpr';
/*
  Generated class for the LicenseplateProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class LicenseplateProvider {
  private apikey = 'sk_db2a1b90c6638e2663df27cd';
  private apibaseurl = 'api.openalpr.com/v2/';

  constructor(public http: Http, public userData: UserData, public common: CommonData, public openALPR: OpenALPR) {
    
  }

  remoteFindLicenseplateByURL(fileurl, recognizevehicel = 0){
    let params = JSON.stringify({image_url:encodeURIComponent(fileurl)}); 
    //console.log(params);
    let url = 'https://api.openalpr.com/v2/recognize_url?recognize_vehicle='+recognizevehicel+'&country=eu&secret_key='+this.apikey+'&image_url='+encodeURIComponent(fileurl);
    return this.http.post(url, params);

  }
  remoteFindLicenseplate(base64data, recognizevehicel = 0){
    let url = 'https://api.openalpr.com/v2/recognize_bytes?recognize_vehicle='+recognizevehicel+'&country=eu&secret_key='+this.apikey;
    return this.http.post(url,base64data);
  }


  localFindAutonummer(fileurl){
    const scanOptions: OpenALPROptions = {
      country: this.openALPR.Country.EU,
      amount: 5
   }

   return this.openALPR.scan(fileurl, scanOptions);
  }

}



// WEBPACK FOOTER //
// ./src/providers/licenseplate/licenseplate.ts